import type { CategoryDataSource } from '~/api/data-source/category';
import { categoryDataSource } from '~/api/data-source/category';
import type { OAISchema } from '~/types/openapi';

// Response 타입
type CategoryTree = OAISchema['DisplayCategoryTreeResponse'];

export interface CategoryRepository {
  getCategoryTree(): Promise<CategoryTree>;
}

export class CategoryRepositoryImpl implements CategoryRepository {
  // eslint-disable-next-line no-useless-constructor
  constructor(
    private readonly dataSource: CategoryDataSource = categoryDataSource,
  ) {}

  async getCategoryTree() {
    return this.dataSource.getCategoryTree();
  }
}

export const categoryRepository = new CategoryRepositoryImpl();
